export class TeamsManager extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        teams-manager p {
          margin-bottom: 20px;
        }
        teams-manager #teams_table_wrapper {
          margin-top: 20px;
        }
      </style>
      <div id="teams-container">
        <div>
          <div class="row">
            <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div class="errors"></div>
              <h3 style="float: left;width: 100%;">
                Manage Teams
              </h3>
              <p>A Team is a custom group of users. Teams handle your incoming text and chat messages.</p>
              <div class="col-sm-3 no-gutters">
                <input class="form-control" placeholder="Enter Team Name" type="text" name="team_name" data-cy=teams_create_value>
              </div>
              <div class="col-sm-6">
                <a class="btn btn-primary" data-cy=teams_create_btn>Add Team</a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" style="display:flex; justify-content: space-between; margin-bottom: 10px;">
            </div>
          </div>
        </div>
        
        <table id="teams_table" class="table datatable" style="width:100%">
          <thead>
            <tr>
              <th>Teams</th><th>Active</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>

          <tbody>
        </table>
      </div>`;
    let group_id = document.querySelector("#object_id").value

    this.table = $("#teams_table").DataTable({
      dom: 'tip',
      "autoWidth": false,
      "rowId": 'team_id',
      "columns": [
        {
          "data": "name"
        },
        {
          data: "is_used",
          "render": function ( data, type, row ) {
            return ( type === 'display') ? '<span class="fa '+((data==true) ? "fa-check":"fa-times")+'"></span>' : data
          }, // feature
          "class": "text-center",
        },
        {
          render: function( data, type, row ) {
            return `<a href='#edit' data-cy=team_edit>Edit</a> ${row.is_used ? "" : " | <a href='#delete' data-cy=team_delete>Delete</a>"}`
          },
          "class": "text-center",
          width: "10%"
        }
      ],
      order: [[ 0, "desc" ]]
    });

    console.log(this.data.teams)
    this.table.rows.add(this.data.teams).draw();

    $(this.querySelector("table")).on("click", "a[href='#delete']", function(e) {
      e.preventDefault();
      let row = this.table.row(e.target.closest('tr'));
      this.remove(row);
    }.bind(this));

    this.querySelector(".btn").addEventListener("click", function(e) {
      e.preventDefault();
      this.add();
    }.bind(this));

    $(this).find('#teams_table').on('click', 'a[href="#edit"]', function(e) {
      e.preventDefault();
      let tr  = $(e.target).closest('tr')
      let data = this.table.row(tr).data();
      this.hide()
      let editPage = new TeamsEdit(data, this.show.bind(this), this.updateTeam.bind(this));
      this.appendChild(editPage)
    }.bind(this))

    //table.row( this ).data()
  }

  hide() {
    this.querySelector("#teams-container").classList.add("hidden");
  }

  show() {
    this.querySelector("#teams-container").classList.remove("hidden");
  }

  updateTeam(data) {
    this.table.row(`#${data.team_id}`).data(data).draw()

  }

  async add() {
    let group_id = document.querySelector("#object_id").value
    let team_name = this.querySelector("input[name='team_name']").value.trim();
    this.querySelector(".errors").innerHTML = "";
    if(team_name == "") {
      this.querySelector(".errors").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <strong>Warning!</strong> team is incomplete.
            </div>`
      return;
    }
    let team = {"name": team_name};
    
    let res = await fetch(`/admin/groups/${group_id}/teams`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(team)
      })
    let data = await res.json();

    if(data["error"] == "RecordNotUnique") {
      this.querySelector(".errors").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <strong>Warning!</strong> team already exists.
            </div>`
    } else {
      Common.notify("New team created", 'success');
      (new DataBinder("/admin/groups/"+group_id+"/teams", true)).fetchData()
      this.table.row.add(data).draw();
      this.clear();
    }
  }

  clear() {
    this.querySelector("input[name='team_name']").value = "";
  }

  async remove(row) {
    let group_id = document.querySelector("#object_id").value
    let row_data = row.data();
    if(confirm(`Delete the team "${row_data["name"]}"`)) {
      let res = await fetch(`/admin/groups/${row_data["auto_group_id"]}/teams/${row_data["team_id"]}`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'DELETE'
      });
      let data = await res.json()
      if(data["success"]) {
        Common.notify("Successfully deleted team", 'success');
        (new DataBinder("/admin/groups/"+group_id+"/teams", true)).fetchData()
        document.querySelector('group-users').reloadTableData();
        this.table.row(row).remove().draw();
      }
    }
  }
}

customElements.define("teams-manager", TeamsManager)

class TeamsEdit extends HTMLElement {
  constructor(data, close, teamUpdated) {
    super();
    this.data = data;
    this.close = close;
    this.teamUpdated = teamUpdated;
  }

  connectedCallback() {
    this.innerHTML = `
                      <style>
                        .back-chevron:before {
                          content: "\\f053 \\00a0";
                          font-family: "FontAwesome";
                          font-weight: normal;
                        }

                        .back-chevron:hover {
                          cursor: pointer;
                        }
                      </style>
                      <div> 
                        <div class="row">
                          <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="errors"></div>
                            <h3 style="float: left;width: 100%;">
                              <span class="back-chevron"></span>Manage Team (${this.data.name})
                            </h3>
                            <p>A Team is a custom group of users. Teams handle your incoming text and chat messages.</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="panel-default" style="margin: 0px 100px 10px">
                              <ul class="nav nav-tabs nav-justified" role="tablist" style="margin-top: 0px">
                                <li class="active"><a class="team-settings-tab nav-link active" href="team-general-settings">General Settings</a></li>
                                <li><a class="team-settings-tab nav-link" href="team-notifications">Notifications</a></li>
                              </ul>
                            </div>
                          </div>
                            
                          <div class="col-xs-12" id="team-settings-content">
                          
                          </div>
                        </div>
                      </div>
                      `;


    let general_settings = new TeamGeneralSettings(this.data, this.closeEdit.bind(this), this.teamUpdated);
    this.querySelector('#team-settings-content').appendChild(general_settings);

    let team_notifications = new TeamNotifications(this.data, this.closeEdit.bind(this), this.teamUpdated);
    team_notifications.classList.add('hidden');
    this.querySelector('#team-settings-content').appendChild(team_notifications);

    this.querySelector('.back-chevron').addEventListener("click", this.closeEdit.bind(this))

    this.querySelectorAll('.team-settings-tab').forEach(elem => {
      elem.addEventListener('click', function(e) {
        this.tabActive(e);
      }.bind(this));
    });
  }

  closeEdit() {
    this.close();
    this.remove();
  }

  tabActive(e) {
    e.preventDefault()
    this.querySelectorAll('.active').forEach(elem => {
      elem.classList.remove('active');
    })
    e.target.closest('li').classList.add('active');
    this.querySelector('#team-settings-content').children.forEach(elem => {
      elem.classList.add("hidden")
    })
    document.querySelector(e.target.getAttribute('href')).classList.remove("hidden");
  }
}
customElements.define("teams-edit", TeamsEdit)


class TeamGeneralSettings extends HTMLElement {
  constructor(data, close, teamUpdated) {
    super();
    this.data = data;
    this.close = close;
    this.teamUpdated = teamUpdated;
  }

  connectedCallback() {
    this.innerHTML = `
        <h4>Team Name</h4>
        <div class="errors" data-cy="team-errors"></div>
        <input type="text" class="form-control" id="team-name" data-cy="team-name" placeholder="" maxlength="40" value="${this.data.name}">

        <div class="col-md-12 location-settings-buttons">
          <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-message-center-settings">Save</button>
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
        </div>
      `;

    this.querySelector('.cancel').addEventListener('click', this.close)
    this.querySelector('.save').addEventListener('click', this.save.bind(this))
  }

  async save() {
    if(this.validate()) {
      let data = {
        name: this.querySelector("input").value.trim()
      }

      this.querySelector('.save').setAttribute("disabled", true);
      
      let res = await fetch(`/admin/groups/${this.data.group_id}/teams/${this.data.team_id}`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'PUT',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('Team Settings updated', 'success');
        this.data = response.data;
        this.teamUpdated(this.data);
        this.connectedCallback();
      } else {
        Common.notify(`Unable to update Team settings. ${response.error ? response.error : ""}`, 'error');
      }
      this.querySelector('.save').removeAttribute("disabled");
    }
  }

  validate() {
    let isValid = true;
    let errors = "";
    
    if(this.querySelector("input").value.trim().length <= 0) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <strong>Warning!</strong> Please enter a valid Team Name.
                </div>`;
      elem.classList.add('error')
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;
    return isValid;
  }
}
customElements.define("team-general-settings", TeamGeneralSettings)


class TeamNotifications extends HTMLElement {
  constructor(data, close, teamUpdated) {
    super();
    this.data = data;
    this.close = close;
    this.teamUpdated = teamUpdated;
  }

  connectedCallback() {
    this.deletedNumbers = [];
    this.innerHTML = 
      `
      <div class="col-sm-12 no-gutters">
        <h3>Notification Preferences</h3>
        <p>Select notifications and send the notifications as text messages to contact phone numbers of your choice</p>
      </div>
      <div class="errors" data-cy="team-notifications-errors"></div>
      <div class="col-sm-6 no-gutters location-settings-switch-div">
        <h4>When no agents are online send notifications</h4>
        <label class="switch">
          <input type="checkbox" class="form-control switch" id="MC-offline-notifications" ${this.data.no_agents_available_sms_enabled ? 'checked' : ''}>
          <span data-cy="MC-offline-notifications-switch"></span>
        </label>
      </div>
      <div class="col-sm-7 no-gutters ${this.data.no_agents_available_sms_enabled ? '' : 'hidden'}" id="text-notification-recipients">
        <h4>Text Notification Recipients</h4>
        <label>Phone Number</label>
        <br>
        <div class="col-sm-9 no-gutters" id="text-notification-recipients-container">
        </div>
        <div class="col-sm-4 pull-right no-gutters">
          <button class="btn btn-outline-success pull-right" id="tnr-button">Add Numbers</button>
        </div>
      </div>
      <div class="col-md-12 location-settings-buttons">
        <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-message-center-settings">Save</button>
        <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
      </div>
      `;

    this.querySelector('#tnr-button').addEventListener('click', (e) => {
      e.preventDefault();
      this.addTextNotificationRecipient();
    })

    this.querySelector('[data-cy="MC-offline-notifications-switch"]').addEventListener('click', function() {
      this.toggleTNR();
    }.bind(this))

    if(this.data.no_agents_available_sms_target != null) {
      this.data.no_agents_available_sms_target.children.forEach(target_child => {
        let target = target_child.destination;
        this.addTextNotificationRecipient(target_child)
      });
    }
    this.querySelector('.cancel').addEventListener('click', this.close)
    this.querySelector('.save').addEventListener('click', this.save.bind(this))
  }

  addTextNotificationRecipient(number = null, id = null) {
    if(number == null) {
      let recipient = new TextNotificationRecipient;
      this.querySelector('#text-notification-recipients-container').appendChild(recipient)
    } else {
      let recipient = new TextNotificationRecipient(number, id);
      this.querySelector('#text-notification-recipients-container').appendChild(recipient)
    }
    this.buttonVisibility();
  }

  toggleTNR() {
    if(this.querySelector('#MC-offline-notifications').checked) {
      this.querySelector('#text-notification-recipients').classList.add('hidden');
    } else {
      this.querySelector('#text-notification-recipients').classList.remove('hidden');
    }
  }

  getNumbers() {
    let numbers_array = [];
    this.querySelectorAll('text-notification-recipient').forEach(elem => {
      numbers_array.push(elem.getNumber());
    })
    if(this.deletedNumbers.length > 0) {
      this.deletedNumbers.forEach(obj => {
        numbers_array.push(obj);
      })
    }
    return numbers_array;
  }

  addDeletedNumbers(data) {
    // Post data for existing numbers being deleted
    this.deletedNumbers.push(data);
  }

  buttonVisibility() {
    if(this.querySelectorAll('text-notification-recipient').length >= 5) {
      this.querySelector('#tnr-button').classList.add('hidden');
    } else {
      this.querySelector('#tnr-button').classList.remove('hidden');
    }
  }

  validate() {
    let isValid = true;
    let errors = "";
    let unique_numbers = [];
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })

    if(this.querySelector('#MC-offline-notifications').checked) {
      let valid_number = true;
      this.querySelectorAll('.tnr-number').forEach(elem => {
        if(unique_numbers[elem.value]) {
          errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please enter phone number only once.
                    </div>`;
          elem.classList.add('error')
          isValid = false;
        } else {
          unique_numbers[elem.value] = true;
        }
        if(!elem.value) {
          elem.classList.add('error')
          valid_number = false
        }
      })
      if(!valid_number || !this.querySelector('text-notification-recipient')) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide recipient phone numbers when Text Notifications are enabled.
                  </div>`;
        isValid = false;
      }
    }

    this.querySelector('.errors').innerHTML = errors;
    return isValid;
  }

  async save() {
    if(this.validate()) {
      this.querySelector('.save').setAttribute("disabled", true);
      let data = {
        no_agents_available_sms_enabled: this.querySelector('#MC-offline-notifications').checked ? 1 : 0,
        text_notification_recipients: this.querySelector('#MC-offline-notifications').checked ? this.getNumbers() : null
      };
      
      let res = await fetch(`/admin/groups/${this.data.group_id}/teams/${this.data.team_id}/text_notifications`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('Team Notification Settings updated', 'success');
        this.data = response.data;
        this.teamUpdated(this.data)
        this.connectedCallback();
      } else {
        Common.notify(`Unable to update Team Notification settings. ${response.error ? response.error : ""}`, 'error');
      }
      this.querySelector('.save').removeAttribute("disabled");
    }
  }
}
customElements.define("team-notifications", TeamNotifications)

class TextNotificationRecipient extends HTMLElement {
  constructor(target_child = null) {
    super();
    this.removeRecipient = this.removeRecipient.bind(this);
    this.target_child = target_child;
    this.target = target_child ? target_child.destination : null;
    this.deletedNumbers;
  }
  connectedCallback() {
    this.innerHTML = 
      `
      <div class="row" style="margin-bottom:5px; position:relative;">
        <div class="col-md-8 no-gutters">
          <input type="text" class="tnr-number form-control" value="${this.target ? this.target.ring_to_endpoint : ''}">
        </div>
        
        <div class="col-md-4 pull-right no-gutters" style="line-height:30px;">
          <button class="btn btn-outline-warning remove_recipient pull-right">Remove</button>
        </div>
      </div>
      `;

    $(this.querySelector(".tnr-number")).mask('(999) 999-9999');
    this.querySelector(".remove_recipient").addEventListener("click", this.removeRecipient.bind(this))
  }
  addRecipient() {
    let recipient = new TextNotificationRecipient();
    this.closest("#text-notification-recipients-container").appendChild(recipient);
  }

  removeRecipient() {
    if(this.target) {
      // Post data for existing hours being deleted
      document.querySelector('team-notifications').addDeletedNumbers({number: this.target.ring_to_endpoint, target_id: this.target.target_id, target_child_id: this.target_child.target_child_id, _deleted: true})
    } 
    this.remove();
    document.querySelector('team-notifications').buttonVisibility();
  }

  getNumber() {
    let numbers = {
      number: this.querySelector('.tnr-number').value ? this.querySelector('.tnr-number').value.replace(/\D/g,'') : null,
      target_id: this.target ? this.target.target_id : null,
      _deleted: false
    };
    return numbers;
  }
}

customElements.define('text-notification-recipient', TextNotificationRecipient)

